import { secondary } from "../../commons/constants/colors";

interface TitleProps {
	children: any;
}

export default function Title(props: TitleProps) {
	const { children } = props;
	return (
		<div
			style={{
				width: "100%",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				marginTop: "20px",
				marginBottom: "20px",
			}}
		>
			<div
				style={{
					flex: 1,
					height: "1px",
					backgroundColor: secondary,
				}}
			/>
			{/* nowrap: con width:50% en las líneas, cualquier título de más de
			    una palabra se partía en dos renglones */}
			<h2
				style={{
					textAlign: "center",
					margin: "0 10px",
					color: secondary,
					textTransform: "uppercase",
					whiteSpace: "nowrap",
				}}
			>
				{children}
			</h2>
			<div
				style={{
					flex: 1,
					height: "1px",
					backgroundColor: secondary,
				}}
			/>
		</div>
	);
}
